import introJs from 'intro.js'
import 'intro.js/minified/introjs.min.css'
import './tourStyles.css'

export function createTour (config) {
  const tour = introJs()

  tour.setOptions({
    disableInteraction: config.disableInteraction,
    steps: config.steps,
    showProgress: config.showProgress,
    showBullets: config.showBullets,
    showStepNumbers: config.showStepNumbers,
    exitOnOverlayClick: config.exitOnOverlayClick,
    exitOnEsc: config.exitOnEsc,
    nextLabel: config.nextLabel,
    prevLabel: config.prevLabel,
    skipLabel: config.skipLabel,
    doneLabel: config.doneLabel
  }).onBeforeChange(config.onBeforeChange).onComplete(config.onComplete).onExit(config.onExit)

  return {
    start: () => tour.start(),
    exit: () => tour.exit(),
    goToStep: (step) => tour.goToStep(step),
    getInstance: () => tour
  }
}
